import * as React from "react";

import type { DesignaliProps } from "../../types";

export const Behance = React.forwardRef<SVGSVGElement, DesignaliProps>(
  ({ ...props }, forwardedRef) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        {...props}
        ref={forwardedRef}
      >
        <circle
          strokeWidth={0}
          fill="#1769ff"
          cx="11.15"
          cy="11.15"
          r="11.15"
        />
        <path
          strokeWidth={0}
          fill="#fff"
          d="M15.53,7.79c-.63,0-1.27,0-1.9,0-.02,0-.05,0-.07,0-.03,0-.05-.01-.05-.05,0-.34,0-.69,0-1.03,0-.04.02-.05.05-.04.02,0,.04,0,.06,0,1.27,0,2.54,0,3.81,0,.12,0,.11-.02.11.11,0,.3,0,.6,0,.91,0,.02,0,.04,0,.06,0,.03-.02.05-.05.05-.02,0-.05,0-.07,0-.63,0-1.26,0-1.89,0Z"
        />
        <path
          strokeWidth={0}
          fill="#fff"
          d="M11.45,12.31c-.13-.43-.36-.8-.71-1.09-.26-.22-.56-.36-.88-.47-.03,0-.05-.02-.09-.03.02-.03.05-.04.08-.05.15-.08.29-.16.42-.26.39-.29.67-.67.77-1.16.11-.5.09-1-.05-1.49-.12-.42-.37-.76-.72-1.02-.28-.2-.6-.33-.94-.42-.48-.12-.97-.15-1.46-.15-1.51,0-3.01,0-4.52,0-.13,0-.11,0-.11.11,0,3.25,0,6.5,0,9.75,0,.12-.01.11.11.11,1.54,0,3.07,0,4.61,0,.36,0,.71-.02,1.06-.09.47-.09.92-.24,1.33-.5.59-.36.98-.87,1.15-1.55.14-.57.12-1.13-.05-1.69ZM5.43,7.96s0-.03,0-.04c0-.03.01-.05.05-.05.02,0,.04,0,.05,0,.64,0,1.28,0,1.92,0,.23,0,.45.02.67.07.12.03.24.07.35.13.25.14.41.34.47.62.05.24.05.47,0,.71-.08.34-.3.55-.61.68-.21.08-.42.12-.64.12-.35,0-.7,0-1.05,0h0c-.36,0-.73,0-1.09,0-.02,0-.05,0-.07,0-.03,0-.04-.02-.04-.04,0-.02,0-.04,0-.05,0-.71,0-1.43,0-2.14ZM9.36,13.47c-.08.39-.31.65-.67.8-.18.08-.37.11-.57.14-.12.01-.24.02-.36.02-.74,0-1.49,0-2.23,0-.11,0-.1.01-.1-.1,0-.42,0-.84,0-1.27,0-.42,0-.83,0-1.25,0-.02,0-.04,0-.06,0-.05.02-.06.06-.06.08,0,.16,0,.25,0,.68,0,1.37,0,2.05,0,.26,0,.52.03.77.11.09.03.17.07.25.11.27.15.44.37.52.67.08.29.09.58.03.88Z"
        />
        <path
          strokeWidth={0}
          fill="#fff"
          d="M18.99,11.58c-.09-.53-.26-1.03-.55-1.48-.45-.72-1.07-1.21-1.89-1.43-.6-.16-1.22-.17-1.83-.04-.71.15-1.33.49-1.83,1.01-.43.45-.72.99-.88,1.59-.13.48-.16.97-.13,1.46.03.46.12.91.3,1.34.24.58.6,1.07,1.12,1.44.5.36,1.07.55,1.68.63.37.04.74.05,1.11,0,.37-.04.74-.13,1.08-.28.49-.21.9-.53,1.21-.97.23-.33.4-.7.53-1.09,0-.01,0-.02,0-.03-.03-.01-.07,0-.1,0-.28,0-.56,0-.84,0-.24,0-.48,0-.72,0-.05,0-.08.01-.1.06-.04.11-.1.2-.18.29-.18.2-.39.35-.63.45-.52.2-1.04.18-1.55,0-.36-.14-.61-.4-.76-.76-.11-.26-.15-.53-.17-.81,0-.13-.01-.11.1-.11,1.48,0,2.95,0,4.43,0,.2,0,.39,0,.59,0,.07,0,.07,0,.08-.07.02-.39,0-.78-.07-1.17ZM16.98,11.57c-1.01,0-2.02,0-3.03,0-.01,0-.02,0-.04,0-.06,0-.06,0-.05-.06.07-.63.36-1.11.97-1.36.26-.1.53-.12.8-.1.13,0,.25.02.37.05.31.08.55.26.73.53.15.24.25.51.31.79.01.05.03.09.03.14-.03.02-.06.01-.09.01Z"
        />
      </svg>
    );
  },
);

export default Behance;
